/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OnboardingConfigProviderBoardEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const onboardingConfigProviderBoardEntrypoint: EntryPoint<
	OnboardingConfigProviderBoardEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<OnboardingConfigProviderBoardEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-jira-find-onboarding-board-config-provider" */ './OnboardingConfigProviderBoardEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
